import { render, staticRenderFns } from "./EnquiryViaSocialStatItem.vue?vue&type=template&id=251a4111&"
import script from "./EnquiryViaSocialStatItem.vue?vue&type=script&lang=js&"
export * from "./EnquiryViaSocialStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports